import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { authAPI } from "../api/auth.api";
import { AuthActionTypes } from "../actions/actionTypes";

function* getSubsidiaries(action) {
    try {
        const subsidiaries = yield call(() => authAPI.getSubsidiaries());

        yield put({
            type: AuthActionTypes.GET_SUBSIDIARIES_SUCCESS,
            payload: {
                subsidiaries: subsidiaries.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary list.");

        yield put({
            type: AuthActionTypes.GET_SUBSIDIARIES_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiariesWatcher() {
    yield takeLatest(AuthActionTypes.GET_SUBSIDIARIES, getSubsidiaries);
}
